import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card"
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"
import { apiUrl, webComponentScriptUrl, webComponentStyleUrl } from "@/utils/config"
import React, { useEffect, useState } from "react"

declare global {
  namespace JSX {
    interface IntrinsicElements {
      "thru-upload": any
    }
  }
}

const WebComponentTest: React.FC = () => {
  const [apiKey, setApiKey] = useState("")
  const [endpointId, setEndpointId] = useState("")
  const [currentApiUrl, setCurrentApiUrl] = useState(apiUrl)

  console.log("apiKey", apiKey)

  useEffect(() => {
    // Load web component scripts
    const script = document.createElement("script")
    script.type = "module"
    script.src = webComponentScriptUrl
    document.head.appendChild(script)

    const link = document.createElement("link")
    link.rel = "stylesheet"
    link.href = webComponentStyleUrl
    document.head.appendChild(link)

    return () => {
      // Cleanup
      document.head.removeChild(script)
      document.head.removeChild(link)
    }
  }, [])

  return (
    <div className="container mx-auto p-4">
      <Card className="mb-8">
        <CardHeader>
          <CardTitle>Web Component Configuration</CardTitle>
          <CardDescription>Configure the Thru upload web component parameters</CardDescription>
        </CardHeader>
        <CardContent className="space-y-6">
          <div className="grid w-full items-center gap-4">
            <div className="flex flex-col space-y-1.5">
              <Label htmlFor="apiKey">API Key</Label>
              <Input
                id="apiKey"
                value={apiKey}
                onChange={(e) => setApiKey(e.target.value)}
                placeholder="Enter your API key"
              />
            </div>
            <div className="flex flex-col space-y-1.5">
              <Label htmlFor="endpointId">Flow Endpoint ID</Label>
              <Input
                id="endpointId"
                value={endpointId}
                onChange={(e) => setEndpointId(e.target.value)}
                placeholder="Enter the flow endpoint ID"
              />
            </div>
            <div className="flex flex-col space-y-1.5">
              <Label htmlFor="apiUrl">API URL</Label>
              <Input
                id="apiUrl"
                value={currentApiUrl}
                onChange={(e) => setCurrentApiUrl(e.target.value)}
                placeholder="Enter the API URL"
              />
            </div>
          </div>
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle>Web Component Preview</CardTitle>
          <CardDescription>Live preview of the configured web component</CardDescription>
        </CardHeader>
        <CardContent>
          <div className="rounded-lg border p-4">
            {apiKey && endpointId && currentApiUrl ? (
              <thru-upload
                key={`${apiKey}-${endpointId}-${currentApiUrl}`}
                api-key={apiKey}
                flow-endpoint-id={endpointId}
                api-url={currentApiUrl}
              ></thru-upload>
            ) : (
              <div className="text-center py-4 text-muted-foreground">
                Please provide all required configuration values above to preview the web component.
              </div>
            )}
          </div>
        </CardContent>
      </Card>
    </div>
  )
}

export default WebComponentTest
